import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.40007 8.00004L7.40007 10L11.4001 6.00004M15.0667 8.00004C15.0667 11.6819 12.082 14.6667 8.40007 14.6667C4.71817 14.6667 1.7334 11.6819 1.7334 8.00004C1.7334 4.31814 4.71817 1.33337 8.40007 1.33337C12.082 1.33337 15.0667 4.31814 15.0667 8.00004Z",
		stroke: "#008500",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckCircle;
